module.exports = __webpack_public_path__ + "img/lens-160-minus-03.c56225ad.png";